import { FocusEventHandler } from "react";
import { InputWithValidationControl } from "src/components/Inputs/InputWithValidationControl";
import { PASSWORD_MANAGER_IGNORE } from "src/types/passwordManager";

type Props = {
  // Show the required asterisk. Off by default to match the app's convention of
  // marking optional fields instead (see NameForm).
  showRequiredIndicator?: boolean;
  onFocus?: FocusEventHandler;
  isDisabled?: boolean;
};

// Single source of truth for the Date of birth input, shared by NameForm and the
// create-student layout so the field (type, id/name used by the birthdate-change
// warning, required styling) stays identical everywhere.
export const BirthDateField: React.FC<Props> = ({
  showRequiredIndicator = false,
  onFocus,
  isDisabled = false,
}) => (
  <InputWithValidationControl
    inputProps={{ type: "date", ...PASSWORD_MANAGER_IGNORE }}
    id="birth_date"
    name="birth_date"
    label="Date of birth"
    isRequired
    labelProps={
      showRequiredIndicator ? undefined : { requiredIndicator: <></> }
    }
    onFocus={onFocus}
    isDisabled={isDisabled}
  />
);
